<div [ngStyle]="{ 'width': '600px', 'max-width': '90vw' }">
	<dialog-container>
		<vip-paginator
			[paginator]="schoolsService.paginator"
			(pageChanged)="setPaginator($event)"
			[requesting]="schoolsService.loading"
		></vip-paginator>
		<text-filter
			placeHolder="Name"
			(textChange)="filterName($event)"
		></text-filter>
		<cdk-table-component
			[displayColumns]="displayColumns"
			[entities]="tableEntities"
			[dataSource]="dataSource"
		></cdk-table-component>
	</dialog-container>
	<dialog-actions-container [styles]="{ display: 'block', 'margin-bottom': '10px' }">
		<div [ngStyle]="{float: 'right', 'text-align': 'right'}">
			<default-button color="primary" (click)="close()">Close</default-button>
		</div>
	</dialog-actions-container>
</div>
